var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-2 font-semibold text-2xl"},[_vm._v(" Sorry no results found! ")])}
var staticRenderFns = []

export { render, staticRenderFns }